import React from "react";
import "../styles/About.css";

import HeroImg from "../assets/photos/about-hero.png";
import Img1 from "../assets/photos/about-1.png";


function About() {
    return (
        <div className="about-container">

            {/* HERO TEXT ONLY */}
            <section className="about-hero">
                <div className="about-hero-text">
                    <h1>About Us</h1>
                    <p>Strength in Unity, Banking with Dignity</p>
                </div>
            </section>

            {/* HERO IMAGE BELOW BLUE SECTION */}
            <section className="about-hero-image">
                <img src={HeroImg} alt="About Sahyadri Bank" />
            </section>

            {/* CONTENT */}
            <section className="about-content">

                <p>
                    The Sahyadri Sahakari Bank Ltd., founded in 1968 in Mumbai by Namdevrao Anandrao Kadam (Bapu) Mathadi leader and his associates, primarily from Kalbadevi, Bhuleshwar and Satara District and the nearby areas known as the Sahyadri Mountains region. These individuals, including Shri. Baburao Jadhav, Shri. Gulabrao Khopade, Shri. Jaywantrao Chavan, Shri. Vithhal Shinde, Shri. Ganpatrao Jadhav, and Shri. Bhausaheb Kadam, had a history of involvement in the cloth trade in South Mumbai for generations. However, the labourers known as "Mathadies" who worked in this industry lacked proper regulations regarding wages, working hours, and essential benefits such as Provident Fund, medical facilities, and bonuses and they were dependent on Money Lenders, Pathans and Savkars who charged exorbitant interest rates
                </p>

                <div className="about-mid-imgs">
                    <img src={Img1} className="about-mid-img" alt="History" />
                </div>

                <p>
                   Initially these associate’s mood to cloth market situated at Kalbadevi, Bhuleshwar and also other parts of Mumbai and Satara regions and collected from 838 shareholders with the minimum share capital of Rs. 87,000 and share price of Rs.10 Each as required and founded the bank on 09/10/1968 and same was registered with District Deputy Registrar.
                   Shri N A Kadam (Bapu) was appointed as a founder Chairman of the bank and bank commenced its operation with effect from 1968 under his leadership and first Board of Directors.
                   To start the bank, Shri. Kadam familiarized himself with the Maharashtra Co-Operative Societies Act of 1960, earning a Co-Operation Degree as a Limited Duration Course (LDC).  He also appointed Shri. V.Y. Bhosale, the former principal of the college where he completed his LDC, as the ‘General Manager’

                </p>


                <p>
                The bank began functioning. Gradually, the bank began to meet the minimum financial needs of Mathadi workers, offering personal loans of Rs. 500 and more, which provided them with much-needed confidence and stability. The bank's membership grew over time, driven by a shared mission to serve the Mathadi workers and ensure their financial well-being.
                Under the leadership of Shri. Namdevrao Kadam (Bapu), they subsequently established various societies, including "Kapad Bazaar Kamgar Mandal," "Kapadbazar Kamgar Seva Society," and "Vishal Housing Society" in Kandivali Charkop, Mumbai. These societies were founded on the principle of serving the Mathadi workers who engaged in cloth market activities, including the physically demanding task of pulling fully loaded cloth carts across significant distances and up multiple floors.
                Through the Seva Society, they provided essential welfare services such as government-approved ration shops, flour mills, departmental stores offering kerosene, groceries, LIC policies, and transportation of goods. The Housing Society secured a 27-acre plot in Kandivali, where they constructed residential accommodations for Mathadi workers, currently housing 2150 families.

                </p>

                <p>
                In the early days, there were over 60 textile mills in Mumbai, employing over 200,000 workers, with around 75% of them hailing from Western Maharashtra. These workers were hardworking but largely illiterate due to limited educational opportunities in rural Maharashtra. The area's economy relied heavily on farming, and irregular monsoons often added pressure on the migrant workers' families, who looked to their Mumbai-based family members for support.
                As on date over 70% members are held from Mathadi Backgrounds and today the Bank having the network of 8 Branches in Mumbai, Navi Mumbai, Thane and Satara District.

                </p>

                <p>
                The New board of Directors under the leadership Of Shri Amit Laxmanrao Chavan took the affairs of the bank with the support from all the Mathadi workers with the sole intension to turn around the financials position of the bank and put it on the right path. The new board took the charge w.e.f. 03/06/2025 with thumping majority of Sahyadri Parivar Panel under visionary leadership of Shri Amit Laxmanrao Chavan.
                The bank succeeded on many financials’ parameters and regulatory compliances the present Management is very much sure to come out all hurdles and bring the past glory to the Bank.


                </p>
                <p>
                And, Now Bank is Known with new tag line “Adhik Jomane, Adhik Utsahane, Utung Bharari ! ”
                </p>

            </section>

        </div>
    );
}

export default About;
